module.exports = __webpack_public_path__ + "img/icon-birthday.89f03dce.svg";